import moment from 'moment';
import { v4 as uuidV4 } from 'uuid';
import annTools from '../common/pdf/annotations/commonAnnotationTools';
const validAnnotationTypeList = ['freeText', 'ink', 'line', 'info', 'highlight', 'issue'];

// ink and line minimum specifications to allow annotation creation
const minimumSpecBool = function minimumSpecBool(selectableType) {
  let points = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return selectableType === 'line' && points.length >= 2 // at least 2 line points
  || selectableType === 'ink' && points.length >= 1 // at least 1 ink point
;
};

/**
 *  Converts a points array saved in canvas coordinants into pdf coordinants and returns a string
 */
const pathStringFromCanvasCoords = (points, pageNumber) => {
  const correctedPoints = points.map(point => {
    const newPDFPoint = annTools.convertPointToPDFCoords(point, pageNumber);
    return "{".concat(newPDFPoint.x, ", ").concat(newPDFPoint.y, "}");
  });
  return correctedPoints.join('/');
};

// get all issue labels in the doc, parse the ones that are integers, take the max and add 1
const label = list => {
  const issues = (list || []).filter(next => next.issue && next.issue.content);
  const issuesWithNumberLabels = []; // can't default to [0], there may be a -num as max label
  issues.forEach(_ref => {
    let content = _ref.issue.content;
    const issueContent = typeof content === 'string' ? JSON.parse(content) : content;
    if (issueContent.label && issueContent.label === parseInt(issueContent.label, 10).toString()) {
      issuesWithNumberLabels.push(parseInt(issueContent.label, 10));
    }
  });
  // if no integers found - it's the first numeric label, so start at 1
  return Math.max(...(issuesWithNumberLabels.length ? issuesWithNumberLabels : [0])) + 1;
};

// default rectString is at 0,0 and 30x30 (pdf coords)
const rectString = function rectString() {
  let xLocation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let yLocation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let rectWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;
  let rectHeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 30;
  return "{{".concat(xLocation, ", ").concat(yLocation, "}, {").concat(rectWidth, ", ").concat(rectHeight, "}}");
};
const basicAnnotation = (annPageNumber, pageRotation, userID, colorString, reportDocumentID) => ({
  id: uuidV4().toUpperCase(),
  appCreated: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
  appCreatorID: userID,
  colorString,
  // old school string type
  reportDocumentID,
  pageNumber: annPageNumber,
  rotation: pageRotation
});
const typedAnnotation = (reportAnnotationID, userID) => ({
  id: uuidV4().toUpperCase(),
  appCreated: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
  appCreatorID: userID,
  reportAnnotationID
});
export default {
  validAnnotationTypeList,
  minimumSpecBool,
  pathStringFromCanvasCoords,
  label,
  rectString,
  basicAnnotation,
  typedAnnotation
};